import { Component } from '@angular/core';
import { Observable, forkJoin, map, of } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';
import { getPriceLevelLabel } from 'src-adisco/utils/getPriceLevelLabel';
import { ComparatorRepository } from 'src-ironside/repositories/comparator.repository'; // TODO
import { Product } from 'src-ironside/repositories/product.repository';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

@Component({
  selector: 'app-product-comparator',
  templateUrl: './product-comparator.component.html',
  styleUrls: ['./product-comparator.component.css'],
})
export class ProductComparatorComponent {
  products?: Product[];
  listIdProduct: any[] = [];
  listProduct: any[] = [];
  listImageSustainableDevelopments = [
    {
      id: 1,
      field: 'europeanEcolabel',
      label: 'Ecolabel Européen',
      urlImage: 'src-adisco/assets/images/sustainable-developments/ECOLABEL_EUROPEEN.png'
    },
    {
      id: 2,
      field: 'cradleToCradle',
      label: 'Cradle to Cradle (C2C)',
      urlImage: 'src-adisco/assets/images/sustainable-developments/cradle-to-cradle.png'
    },
    {
      id: 3,
      field: 'nordicSwan',
      label: 'Nordic Swan',
      urlImage: 'src-adisco/assets/images/sustainable-developments/swan_nordic_label.png'
    },
    {
      id: 4,
      field: 'austrianEcolabel',
      label: 'Ecolabel Autrichien',
      urlImage: 'src-adisco/assets/images/sustainable-developments/ecolabel_autrichien.png'
    },
    {
      id: 5,
      field: 'ecocert',
      label: 'Ecocert',
      urlImage: 'src-adisco/assets/images/sustainable-developments/Logo_Ecocert_Colour.png'
    },

    {
      id: 6,
      field: 'emas',
      label: 'EMAS',
      urlImage: 'src-adisco/assets/images/sustainable-developments/EMAS.png'
    },
    {
      id: 7,
      field: 'fsc',
      label: 'FSC',
      urlImage: 'src-adisco/assets/images/sustainable-developments/FSC.png'
    },
    {
      id: 8,
      field: 'reach',
      label: 'REACH',
      urlImage: 'src-adisco/assets/images/sustainable-developments/REACHCompliant.png'
    },
    {
      id: 9,
      field: 'foodContact',
      label: 'Contact alimentaire',
      urlImage: 'src-adisco/assets/images/sustainable-developments/1200px-EU_food_contact_material_symbol.png'
    },
    {
      id: 10,
      field: 'clpSafetyPicto',
      label: 'CLP (pictos de sécurité)',
      urlImage: 'src-adisco/assets/images/sustainable-developments/sans-picto-danger.svg',
      parseToBooleanValueTrue: "SANS"
    },
    {
      id: 11,
      field: 'biocide',
      label: 'BIOCIDE',
      urlImage: 'src-adisco/assets/images/sustainable-developments/Produit_Biocide.png'
    }
  ];

  listProductCompare: any[] = JSON.parse(localStorage.getItem('compare') as any);

  constructor(
    private _commonService: CommonService,
    private comparatorRepository: ComparatorRepository,
    private dynamicDocumentService: DynamicDocumentService,
    public userService: UserService
  ) {
    if (this.listProductCompare) {
      this.listProduct = this.listProductCompare;
      this.listIdProduct = this.listProduct.map((ele) => {
        return ele?.id;
      })
    }
    this._commonService.getClickCompare().subscribe((data) => {
      // data?.forEach((item: any) => {
      //   this.listIdProduct.push(item?.documentId);
      // });
      // console.log(this.listIdProduct);

      if (this.listIdProduct.length > 0 && this.listIdProduct) {
        this.getListProductComparators(this.listIdProduct);
      }
    });
    this._commonService.getClickCompareComplete().subscribe((data) => {
      window.location.reload();
    });
  }

  ngOnInit(): void {
    // this.comparatorRepository.getMyComparators().subscribe((res) => {
    //   this.products = res;
    // });

  }
  getListProductComparators(ids: any[]): void {
    this._commonService.getListComparer(ids).subscribe({
      next: (res) => {
        this.listProduct = res?.response;
        const supplierRequests = this.listProduct.map(product =>
          this.getNameSupplier(product?.nameSupplier[0]?.value) // we will remove this later
        );

        // const imageRequests = this.listProduct.map(product =>
        //   product?.supplierItemNumber
        //     ? this.getListImage(product?.supplierItemNumber)
        //     : of('src-adisco/assets/images/image-default.jpeg')
        // );

        // const tariffRequests = this.listProduct.map(product => {
        //   if (product?.linkToTariff && product?.linkToTariff[0]) {
        //     const listIdTariff: any[] = product.linkToTariff.map((item: any) => item?.documentId);
        //     return this.getTariff(listIdTariff);
        //   } else {
        //     return of('');
        //   }
        // });

        forkJoin([...supplierRequests /*, ...imageRequests, ...tariffRequests */]).subscribe(results => {
          const supplierResults = results.slice(0, supplierRequests.length);
         // const imageResults = results.slice(supplierRequests.length, supplierRequests.length + imageRequests.length);
          //const tariffResults = results.slice(supplierRequests.length + imageRequests.length);

          this.listProduct = this.listProduct.map((product, index) => ({
            ...product,
            companyName: supplierResults[index],
            //urlImage: imageResults[index],
           // price: tariffResults[index]?.price,
          //  priceLevelLabel: getPriceLevelLabel(tariffResults[index].priceLevel)
          }));

        });
      },
      error: (error) => { },
    });
  }
  getTariff(ids: any[]): Observable<any> {
    return this._commonService.getDataTariff(ids).pipe(
      map((res) => {
        const data = res.response;
        const filteredData = data.filter((item: any) => item?.year && item?.year?.value === "N");
        if (filteredData.length > 0) {
          const latestItem = filteredData.reduce((prev: any, current: any) => {
            return (prev.price > current.price) ? prev : current;
          });
          return { price: latestItem?.price, priceLevel: latestItem?.priceLevel?.value };
        }
        return '';
      })
    );
  }
  getListImage(supplierItemNumber: any): Observable<string> {
    return this.dynamicDocumentService.find({
      collectionName: 'dynamic_ressource',
      filters: [
        {
          fieldName: 'linkToProduct',
          conditions: [
            {
              type: 'EQUALS',
              value: supplierItemNumber,
              minValue: '',
              maxValue: ''
            }
          ]
        }
      ],
      sorts: {},
      page: 1,
      pageSize: 25
    }).pipe(
      map((res: any) => {
        const dataListImage = res.content;
        const firstMatchingItem = dataListImage.find((item: any) => {
          return item.typeOfResource?.value === 'PHOTO' && item.file?.length > 0;
        });
        return firstMatchingItem?.file[0]?.url || 'src-adisco/assets/images/image-default.jpeg';
      })
    );
  }
  getNameSupplier(code: any): Observable<any> {
    return this.dynamicDocumentService.find({
      collectionName: 'dynamic_legal_entity',
      filters: [
        {
          "fieldName": "code",
          "conditions": [
            {
              "type": "EQUALS",
              "value": code
            }
          ]
        }
      ],
      page: 1,
      pageSize: 150
    }).pipe(
      map((res: any) => {
        if (res.content[0]?.companyName != null) {
          return res.content[0].companyName;
        }
        return '';
      })
    );
  };


  displayImgSusDev(imgSusDev: any, itemData: any) {
    let expectedValue = typeof itemData === "boolean" ? itemData : (itemData?.value ?? undefined);

    if (imgSusDev?.parseToBooleanValueTrue !== null && imgSusDev?.parseToBooleanValueTrue !== undefined) {
      return expectedValue === imgSusDev.parseToBooleanValueTrue
    }

    return expectedValue ?? false;
  }
}
